
import { defineComponent } from '@vue/composition-api';
import IllinoisIcons from '../icons.vue';
import type {
  AcceptingBet,
  AcceptedBet,
  AcceptedBetWithChange,
  RejectedBet
} from '../../../../../types/sport';

export default defineComponent({
  name: 'IllinoisBetInAcceptance',
  components: {
    IllinoisIcons
  },
  data() {
    return {
      showModal: false,
      modalMessage: ''
    };
  },
  computed: {
    acceptingBets(): AcceptingBet[] {
      return this.$store.getters['cart/getAcceptingBets'] || [];
    },
    acceptedBets(): AcceptedBet[] {
      return this.$store.getters['cart/getAcceptedBets'] || [];
    },
    acceptedWithChange(): AcceptedBetWithChange[] {
      return this.$store.getters['cart/getAcceptedBetWithChange'] || [];
    },
    rejectedBets(): RejectedBet[] {
      return this.$store.getters['cart/getRejectedBets'] || [];
    }
  },
  methods: {
    t(key: string): string {
      return this.$t(key) as string;
    },
    handlePrint(bet: AcceptedBet): void {
      this.$root.$emit('print_this_bet', bet);
    },
    handleRemoveAccepted(betCode: string): void {
      this.$store.dispatch('cart/removeBetFromAcceptedBets', betCode);
    },
    handleRemoveRejected(betCode: string): void {
      this.$store.dispatch('cart/removeBetFromRejectedBets', betCode);
    },
    async handleAcceptReview(betCode: string): Promise<void> {
      const result = await this.$store.dispatch('cart/acceptsRevisedBet', {
        code: betCode
      });

      if (result == null) {
        this.modalMessage = this.t('Something went wrong!');
        this.showModal = true;
        return;
      }

      if (result.data && result.data.result) {
        this.modalMessage = this.t('betRevivedAccepted');
        this.showModal = true;
      } else {
        this.modalMessage = this.t('Something went wrong!');
        this.showModal = true;
      }
      this.$store.dispatch('cart/removeBetFromAcceptedWithChange', betCode);
    },
    async handleRejectReview(betCode: string): Promise<void> {
      const result = await this.$store.dispatch('cart/rejectRevisedBet', {
        code: betCode
      });

      if (result == null) {
        this.modalMessage = this.t('Something went wrong!');
        this.showModal = true;
        return;
      }

      if (result.data && result.data.result) {
        this.modalMessage = this.t('betRevivedNotAccepted');
        this.showModal = true;
      } else {
        this.modalMessage = this.t('Something went wrong!');
        this.showModal = true;
      }
      this.$store.dispatch('cart/removeBetFromAcceptedWithChange', betCode);
    },
    closeModal(): void {
      this.showModal = false;
      this.modalMessage = '';
    }
  }
});
